import React from "react";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";
import cx from "classnames";
import { connect } from "react-redux";

import { getPublicCategories } from "../../actions/action_categories";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import ListItemText from "@material-ui/core/ListItemText";
import PersonIcon from "@material-ui/icons/Person";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Typography } from "@material-ui/core";

import mainNavBarStyle from "assets/jss/material-dashboard-pro-react/components/mainNavBarStyle.jsx";
import { bindActionCreators } from "redux";
import { getStore } from "../../store/configureStore";
import { updateIntlProv } from "../../utils/intl";
import { replaceHistoryWithoutLanguage } from "../../utils/analytics";
import { IntlProvider, addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import { flattenMessages } from "../../utils/helper";
import messages from "../../locale/index";
addLocaleData([...en, ...es]);

class MainNavBar extends React.Component {
  ShowTheLocationWithRouter = withRouter(MainNavBar);
  constructor(props) {
    super(props);
    const storedLang = this.getStoredLanguage();
    this.state = {
      open: false,
      anchorEl: null,
      lang: storedLang,
      gtLang: "en",
    };
    this.googleTranslateObserver = null;
    this.props.getPublicCategories({});
  }

  componentDidMount() {
    const store = getStore();
    const currentLang = this.getStoredLanguage();
    const urlDrivenLang = new URLSearchParams(window.location.search).get("lang") === "es";
    const storedLangBefore = localStorage.getItem("lang");
    if (store.getState().langReducer.lang !== currentLang) {
      store.dispatch({
        type:
          currentLang === "es"
            ? "CHANGE_LANG_SPANISH"
            : "CHANGE_LANG_ENGLISH",
      });
    }
    if (urlDrivenLang && storedLangBefore !== "es") {
      if (storedLangBefore === null) {
        localStorage.removeItem("lang");
      } else {
        localStorage.setItem("lang", storedLangBefore);
      }
    }
    updateIntlProv(currentLang);
    this.injectGoogleTranslateStyles();
    this.loadGoogleTranslate();
    if (currentLang === "es") {
      this.setState({ gtLang: "es" });
      this.setGoogleTranslateLanguage("es");
    } else if (this.getGoogleTranslateCookieLanguage() === "es") {
      console.info("[language-routing] GT cookie says es — reflecting button label");
      this.setState({ gtLang: "es" });
    }
    console.info("[language-routing] bootstrap complete", {
      currentLang,
      reduxLang: store.getState().langReducer.lang,
      storedLang: localStorage.getItem("lang"),
      gtCookieLang: this.getGoogleTranslateCookieLanguage(),
    });
  }

  componentWillUnmount() {
    if (this.googleTranslateObserver) {
      this.googleTranslateObserver.disconnect();
    }
  }

  getStoredLanguage() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("lang") === "es") {
      console.info("[language-routing] deep link detected (?lang=es)", {
        url: window.location.href,
      });
      return "es";
    }
    const storedLang = localStorage.getItem("lang");
    console.info("[language-routing] resolved language from localStorage", {
      storedLang,
    });
    return storedLang === "es" ? "es" : "en";
  }

  clearGoogleTranslateCookies() {
    const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
    console.info("[language-routing] clearing googtrans cookies", {
      hostname: window.location.hostname,
      cookieBefore: document.cookie,
    });
    const hostParts = window.location.hostname.split(".");
    const domains = [window.location.hostname];

    if (hostParts.length > 1) {
      domains.push("." + hostParts.slice(-2).join("."));
      domains.push("." + hostParts.join("."));
    }

    ["/", window.location.pathname].forEach((path) => {
      document.cookie = `googtrans=; path=${path}; ${expires}`;
      domains.forEach((domain) => {
        document.cookie = `googtrans=; path=${path}; domain=${domain}; ${expires}`;
      });
    });
    console.info("[language-routing] googtrans cookies cleared", {
      cookieAfter: document.cookie,
    });
  }

  getGoogleTranslateCookieLanguage() {
    const googtransCookie = document.cookie
      .split(";")
      .map((cookie) => cookie.trim())
      .find((cookie) => cookie.indexOf("googtrans=") === 0);

    if (!googtransCookie) {
      return "";
    }

    return googtransCookie.split("/").pop();
  }

  injectGoogleTranslateStyles() {
    if (document.getElementById("hide-google-translate-chrome")) return;

    const style = document.createElement("style");
    style.id = "hide-google-translate-chrome";
    style.textContent = `
      .goog-te-banner-frame,
      iframe.skiptranslate {
        display: none !important;
      }
      div.skiptranslate {
        height: 0 !important;
        overflow: hidden !important;
      }
      #goog-gt-tt, .goog-te-balloon-frame,
      .goog-tooltip, .goog-tooltip:hover {
        display: none !important;
      }
      .goog-text-highlight,
      font[style] {
        background: none !important;
        background-color: transparent !important;
        background-image: none !important;
        border: none !important;
        box-shadow: none !important;
        color: inherit !important;
      }
      #google_translate_element {
        position: fixed;
        left: 0;
        bottom: 0;
        opacity: 0;
        pointer-events: none;
        z-index: -1;
      }
      body { top: 0 !important; }
    `;
    document.head.appendChild(style);

    // Only observe body.style.top changes that Google Translate forces
    this.googleTranslateObserver = new MutationObserver(() => {
      if (document.body.style.top && document.body.style.top !== "0px") {
        document.body.style.top = "0px";
      }
    });
    this.googleTranslateObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  loadGoogleTranslate() {
    console.log("[GT] loadGoogleTranslate called");

    // Create the container div if it doesn't exist
    if (!document.getElementById("google_translate_element")) {
      var el = document.createElement("div");
      el.id = "google_translate_element";
      document.body.appendChild(el);
      console.log("[GT] Created google_translate_element div");
    } else {
      console.log("[GT] google_translate_element div already exists");
    }

    // Only load the script once
    if (document.getElementById("google-translate-script")) {
      console.log("[GT] Script already loaded, skipping");
      return;
    }

    window.googleTranslateElementInit = function() {
      console.log("[GT] googleTranslateElementInit FIRED");
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,es",
          autoDisplay: false,
        },
        "google_translate_element"
      );
      var combo = document.querySelector(".goog-te-combo");
      console.log("[GT] After init — combo exists:", !!combo);
    };

    var script = document.createElement("script");
    script.id = "google-translate-script";
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    script.onerror = function(e) {
      console.error("[GT] Script FAILED to load", e);
    };
    script.onload = function() {
      console.log("[GT] Script loaded successfully");
    };
    document.body.appendChild(script);
    console.log("[GT] Script tag appended to body");
  }

  setGoogleTranslateLanguage(langCode) {
    console.log("[GT] setGoogleTranslateLanguage called with:", langCode);

    var combo = document.querySelector(".goog-te-combo");
    console.log("[GT] combo element:", combo);
    console.log("[GT] combo current value:", combo ? combo.value : "N/A");
    console.log("[GT] combo options:", combo ? Array.from(combo.options).map(function(o) { return o.value + "=" + o.text; }) : "N/A");

    if (langCode === "en") {
      this.clearGoogleTranslateCookies();

      // Attempt 1: getInstance().restore()
      console.log("[GT] Trying restore path...");
      console.log("[GT] window.google:", !!window.google);
      console.log("[GT] window.google.translate:", window.google && !!window.google.translate);
      console.log("[GT] TranslateElement:", window.google && window.google.translate && !!window.google.translate.TranslateElement);

      if (window.google && window.google.translate &&
          window.google.translate.TranslateElement) {
        var instance = window.google.translate.TranslateElement.getInstance();
        console.log("[GT] getInstance():", instance);
        console.log("[GT] instance methods:", instance ? Object.keys(instance) : "N/A");
        if (instance && instance.restore) {
          console.log("[GT] Calling instance.restore()");
          instance.restore();
          return;
        }
      }

      // Attempt 2: click restore link in banner iframe
      var iframe = document.querySelector(".goog-te-banner-frame");
      console.log("[GT] banner iframe:", iframe);
      if (iframe) {
        try {
          iframe.style.display = "block";
          var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          console.log("[GT] iframe contentDocument:", !!iframeDoc);
          var restoreBtn = iframeDoc && iframeDoc.querySelector(".goog-close-link");
          console.log("[GT] restore button:", restoreBtn);
          if (restoreBtn) {
            restoreBtn.click();
            setTimeout(function() { iframe.style.display = "none"; }, 100);
            return;
          }
          iframe.style.display = "none";
        } catch (e) {
          console.log("[GT] iframe error:", e.message);
        }
      }

      // Attempt 3: cookie clear + reload
      console.log("[GT] All attempts failed — falling back to cookie clear + reload");
      window.location.reload();
      return;
    }

    // For Spanish — the script loads async, so poll for the combo before handing off.
    this.waitForComboThenTranslate(langCode);
  }

  waitForComboThenTranslate(langCode, maxWait = 5000) {
    var start = Date.now();
    var attempt = () => {
      var combo = document.querySelector(".goog-te-combo");
      if (combo) {
        console.log("[GT] combo ready — setting to:", langCode);
        this.waitForIntlThenTranslate(langCode);
        return;
      }
      if (Date.now() - start < maxWait) {
        setTimeout(attempt, 100);
      } else {
        console.info("[language-routing] combo never appeared after", Date.now() - start, "ms — cannot translate to", langCode);
      }
    };
    console.info("[language-routing] waiting for GT combo", { langCode });
    attempt();
  }

  waitForIntlThenTranslate(langCode) {
    var maxWait = 3000;
    var start = Date.now();

    function hasRawKeys() {
      var body = document.body;
      var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        var text = (node.nodeValue || "").trim();
        // Raw i18n keys look like "view.categoryNames." or "view.filterYourResults.treatmentservices.loading"
        // Match anything starting with "view." that contains only word chars and dots
        if (/^view\.[a-zA-Z.]*$/.test(text)) {
          return true;
        }
      }
      return false;
    }

    function attempt() {
      if (!hasRawKeys()) {
        var freshCombo = document.querySelector(".goog-te-combo");
        if (freshCombo) {
          freshCombo.value = langCode;
          freshCombo.dispatchEvent(new Event("change"));
          console.info("[language-routing] combo change dispatched — intl ready");
        }
        return;
      }
      if (Date.now() - start < maxWait) {
        requestAnimationFrame(attempt);
      } else {
        console.info("[language-routing] intl wait timed out, translating anyway");
        var freshCombo = document.querySelector(".goog-te-combo");
        if (freshCombo) {
          freshCombo.value = langCode;
          freshCombo.dispatchEvent(new Event("change"));
        }
      }
    }

    requestAnimationFrame(attempt);
  }

  componentDidUpdate(prevProps, prevState) {

  }

  servicesMenuOpen(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  servicesMenuClose(event, obj) {
    this.setState({ anchorEl: null });
    if (obj && obj.id) {
      let name = obj.name && obj.name.replace(/\s/g, "").toLowerCase();
      this.props.history.push("/auth/search-service/" + obj.id + "/" + name);
      window.location.reload(false);
      //  this.topNavRoutes(event, type);
    }
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }

  topNavRoutes(event, property, filterObj = []) {
    switch (property) {
      case "home":
        this.props.history.push("/auth/home");
        break;
      case "about":
        this.props.history.push("/auth/about-page");
        break;
      case "treatment":
        this.props.history.push("/auth/search-service/3/treatmentservices");
        break;
      case "harm":
        this.props.history.push("/auth/search-service/4/harmreduction");
        break;
      case "peerandfamily":
        this.props.history.push("/auth/search-service/5/peerandfamilysupport");
        break;
      case "crisisHotline":
        this.props.history.push("/auth/hotlinecategories");
        break;
      case "freeNaloxone":
        this.props.history.push("/auth/search-service/4/harmreduction?filter=" + JSON.stringify(filterObj));
        break;
      case "faq":
        this.props.history.push("/auth/FAQs");
        break;
      case "events":
        this.props.history.push("/auth/events");
        break;
      default:
        break;
    }
  }
  syncLangInUrl(lang) {
    const { history } = this.props;
    if (!history) return;
    const { pathname, search, hash } = history.location;
    const params = new URLSearchParams(search);
    if (lang === "es") {
      params.set("lang", "es");
    } else {
      params.delete("lang");
    }
    const query = params.toString();
    const nextSearch = query ? `?${query}` : "";
    console.info("[language-routing] language URL sync", {
      from: `${pathname}${search || ""}`,
      to: `${pathname}${nextSearch}${hash || ""}`,
      lang,
    });
    replaceHistoryWithoutLanguage(history, { pathname, search: nextSearch, hash });
  }

  changeLanguage(event){
    const store = getStore();
    const currentLang = this.state.lang || this.getStoredLanguage();
    if (currentLang === "es"){
      if (process.env.NODE_ENV !== "production") {
        console.info("[language-routing] switching language", { from: "es", to: "en" });
      }
      this.clearGoogleTranslateCookies();
      console.info("[language-routing] changeLanguage: es -> en", {
        reduxLangBefore: store.getState().langReducer.lang,
      });
      store.dispatch({
        type : "CHANGE_LANG_ENGLISH"
      });
      console.info("[language-routing] changeLanguage: redux + intl now english", {
        reduxLangAfter: store.getState().langReducer.lang,
        storedLang: localStorage.getItem("lang"),
      });
      this.setState({lang : "en", gtLang : "en"})
      updateIntlProv("en")
      this.syncLangInUrl("en")
      this.setGoogleTranslateLanguage("en")
    }else{
      if (process.env.NODE_ENV !== "production") {
        console.info("[language-routing] switching language", { from: "en", to: "es" });
      }
      console.info("[language-routing] changeLanguage: en -> es", {
        reduxLangBefore: store.getState().langReducer.lang,
      });
      store.dispatch({
        type : "CHANGE_LANG_SPANISH"
      });
      console.info("[language-routing] changeLanguage: redux + intl now spanish", {
        reduxLangAfter: store.getState().langReducer.lang,
        storedLang: localStorage.getItem("lang"),
      });
      this.setState({lang : "es", gtLang : "es"})
      updateIntlProv("es")
      this.syncLangInUrl("es")
      this.setGoogleTranslateLanguage("es")
      console.info("[language-routing] changeLanguage: firing gtag spanish event");
      window.gtag("event", "spanish", {
        send_to: "G-F4KZHDWJEE",
      });
    }
  }

  toggleGoogleTranslate() {
    var combo = document.querySelector(".goog-te-combo");
    var cookieLang = this.getGoogleTranslateCookieLanguage();
    var reduxLang = getStore().getState().langReducer.lang;
    var isTranslated = (combo && combo.value === "es") || cookieLang === "es" || reduxLang === "es";
    console.log("[GT] toggleGoogleTranslate — combo value:", combo ? combo.value : "N/A", "isTranslated:", isTranslated);
    if (!isTranslated) {
      console.info("[language-routing] toggleGoogleTranslate: firing gtag spanish event");
      window.gtag("event", "spanish", {
        send_to: "G-F4KZHDWJEE",
      });
    }
    var nextLang = isTranslated ? "en" : "es";
    console.info("[language-routing] toggleGoogleTranslate", {
      comboValue: combo ? combo.value : null,
      cookieLang,
      isTranslated,
      nextLang,
    });
    var store = getStore();
    store.dispatch({
      type: nextLang === "es" ? "CHANGE_LANG_SPANISH" : "CHANGE_LANG_ENGLISH",
    });
    updateIntlProv(nextLang);
    this.setState({ gtLang: nextLang, lang: nextLang });
    this.syncLangInUrl(nextLang);
    this.setGoogleTranslateLanguage(nextLang);
  }

  render() {
    const { classes, categories } = this.props;
    const { anchorEl } = this.state;

    return (
      <IntlProvider locale={this.state.lang} messages={flattenMessages(messages[this.state.lang])}>
      <div className={classes.navBar + " navbar-container"}>
        <Grid container alignItems="center">
          <Grid item md={2}>
            <Button
              className={classes.mainlogo}
              // style={{ padding: "6px 30px" }}
              // href="/auth/home"
              onClick={() => this.props.history.push('/auth/home')}
            >
              {" "}
              {/*  color="transparent" */}
              <img
                alt="DrugHelp Logo"
                src={require("../../assets/img/drughelp.png")}
                className={classes.imageProps}
              />
            </Button>
          </Grid>

          {window.location.href.includes("develop.drughelp.care") && (
            <Grid item xs={12} sm={3} className={classes.devWarning}>
              <Typography variant="subtitle1" color="error">
                Development Server
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} md={7} className={classes.menuItems}>
            <Button
              onClick={(e) => {
                this.topNavRoutes(e, "home");
              }}
              className={classes.submenu}
            >
              {window.intl.formatMessage({ id: "home" })}
            </Button>
            <Button
              onClick={(e) => {
                this.topNavRoutes(e, "about");
              }}
              className={classes.submenu}
            >
              {window.intl.formatMessage({ id: "about" })}
            </Button>
            <Button
              aria-owns={anchorEl ? "services-menu" : null}
              aria-haspopup="true"
              onClick={(e) => {
                this.servicesMenuOpen(e);
              }}
              className={classes.submenu}
            >
              {window.intl.formatMessage({ id: "menu" })}
              <ExpandMoreIcon />
            </Button>
            <Menu
              id="services-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={(e) => {
                this.servicesMenuClose(e, null);
              }}
              MenuListProps={{
                name: "Services",
              }}
              style={{
                top:"5%"
              }}
            >
              {(categories.data || []).map((obj, i) => (
                <MenuItem
                  key={i}
                  onClick={(e) => {
                    this.servicesMenuClose(e, obj);
                  }}
                >
                {window.intl.formatMessage({ id: `view.categoryNames.${obj.name.replace(/\s/g, "").toLowerCase()}` })}
                </MenuItem>
              ))}
              <MenuItem
                onClick={(e) => {
                  this.topNavRoutes(e, "crisisHotline");
                  this.servicesMenuClose(e, null);
                }}
              >
                {window.intl.formatMessage({ id: "view.categoryNames.crisishotlines" })}
              </MenuItem>
              <MenuItem
                onClick={(e) => {
                  this.topNavRoutes(e, "freeNaloxone", [{ name: "Naloxbox Locations" }, { name: "Narcan (Naloxone)" }]);
                  this.servicesMenuClose(e, null);
                }}
              >
                {window.intl.formatMessage({ id: "view.otherResources.freenaloxonebutton" })}
              </MenuItem>
            </Menu>
            <Button
              onClick={(e) => {
                this.topNavRoutes(e, "faq");
              }}
              className={classes.submenu}
            >
              {window.intl.formatMessage({ id: "faq" })}
            </Button>
            <Button
              onClick={(e) => {
                this.topNavRoutes(e, "events");
              }}
              className={classes.submenu}
            >
              {window.intl.formatMessage({ id: "events" })}
            </Button>
            {/* Old manual i18n (react-intl) language toggle — replaced by Google Translate button below
            {
              <Button
              size="large"
              onClick={(e) => {
                this.changeLanguage(e)
              }}
              className={classes.submenu}
            >
              {this.state.lang==="en" ? "Español" : "English"}
            </Button>
            }
            */}
            <Button
              size="large"
              onClick={() => this.toggleGoogleTranslate()}
              className={classes.submenu}
            >
              {this.state.gtLang === "en" ? "Español" : "English"}
            </Button>
          </Grid>
          {!this.props.hideAdminLogin && (
          <Grid item md={3} className={"adminLogin"}>
            <div className={classes.rightMenu}>
              <NavLink
                to={"/auth/login-page"}
                className={cx(classes.navLink, {
                  [classes.navLinkActive]: this.activeRoute("/auth/login-page"),
                })}
              >
                <ListItemText
                  primary={window.intl.formatMessage({id : "adminLogin"})}
                  disableTypography={true}
                  className={classes.listItemText}
                  style={{ color: "#233750" }}
                />
              </NavLink>
              <PersonIcon
                className={classes.listItemIcon}
                style={{ color: "#233750", fontSize: "20px" }}
              />
            </div>
          </Grid>
          )}
        </Grid>
      </div>
    </IntlProvider>
    );
  }
}

MainNavBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    categories: state.categories,
    //changeLang : state.langReducer
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPublicCategories: bindActionCreators(getPublicCategories, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(mainNavBarStyle)(MainNavBar));
